var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("footer d-flex justify-content-center align-items-center bg-white " + (_vm.fixed ? 'position-fixed' : ''))},[_c('p',{staticStyle:{"font-size":"11px","font-weight":"600"}},[_vm._v("Powered by Eatmol")])])}
var staticRenderFns = []

export { render, staticRenderFns }